import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import {
  changeResultsFilters,
  selectChosenFlightsResults,
  selectResultsFilters,
} from "../searchFlightsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useRef, useState } from "react";
import { useOnClickOutside } from "../../../hooks/useOnClickOutside";

function StopsDropdown() {
  const dropdownRef = useRef(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState<boolean>(false);
  const [highlightedIndex, setHighlightedIndex] = useState<number>(0);
  useOnClickOutside(
    dropdownRef,
    useCallback(() => setActive(false), [setActive])
  );
  const [stops, setStops] = useState<number[]>([]);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { stops: selected } = useAppSelector(selectResultsFilters);
  const { flights } = useAppSelector(selectChosenFlightsResults);

  const options = [-1, ...stops];

  const onClick = () => {
    setActive(!active);
    if (!active) {
      setHighlightedIndex(options.indexOf(selected));
      setTimeout(() => menuRef.current?.focus(), 0);
    }
  };

  const onSelect = (value: number) => {
    dispatch(changeResultsFilters({ stops: value }));
    setActive(!active);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) => (prev + 1) % options.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(
        (prev) => (prev - 1 + options.length) % options.length
      );
    } else if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onSelect(options[highlightedIndex]);
    } else if (e.key === "Escape") {
      setActive(false);
    }
  };

  useEffect(() => {
    setStops(extractStops(flights));
  }, [flights]);

  if (stops.length <= 1) {
    return null;
  }
  return (
    <>
      <div className={`dropdown ${active ? " is-active" : ""}`}>
        <div className="dropdown-trigger">
          <button
            className="button"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
            onClick={onClick}
          >
            <span>{t("HEADER_SORT_STOPS")}</span>
            <span className="icon">
              <FontAwesomeIcon icon={faAngleDown} aria-hidden="true" />
            </span>
          </button>
        </div>
        <div
          ref={menuRef}
          className="dropdown-menu"
          id="dropdown-menu"
          role="menu"
          tabIndex={-1}
          onKeyDown={handleKeyDown}
        >
          <ul className="dropdown-content">
            <li>
              <a
                onMouseDown={() => onSelect(-1)}
                onMouseEnter={() => setHighlightedIndex(0)}
                href="#"
                tabIndex={-1}
                className={`dropdown-item${
                  selected === -1 ? " is-active" : ""
                }${highlightedIndex === 0 && active ? " is-highlighted" : ""}`}
              >
                {t("ALL")}
              </a>
            </li>
            {stops.map((stop, i) => {
              return (
                <li key={i}>
                  <a
                    onMouseDown={() => onSelect(stop)}
                    onMouseEnter={() => setHighlightedIndex(i + 1)}
                    href="#"
                    tabIndex={-1}
                    className={`dropdown-item${
                      selected === stop ? " is-active" : ""
                    }${
                      highlightedIndex === i + 1 && active
                        ? " is-highlighted"
                        : ""
                    }`}
                  >
                    {stop}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      &nbsp;
    </>
  );
}

function extractStops(results): number[] {
  const stops = results.map((result) => parseInt(result.stops));
  //@ts-ignore
  return [...new Set(stops)];
}

export default StopsDropdown;
